// menuConstants.js
export const MENU_CONSTANTS = {
  PURCHASE_LIST: 'MENU_WMS_PURCHASE.PURCHASE_ORDER',
  SUPPLIER_LIST: 'MENU_WMS_PURCHASE.SUPPLIERS',
  PURCHASE_DASHBOARD: 'MENU_WMS_PURCHASE.DASHBOARD',

  SALES_LIST: 'MENU_WMS_SALES.SALES_ORDER',
  CUSTOMER_LIST: 'MENU_WMS_SALES.CUSTOMERS',
  SALES_DASHBOARD: 'MENU_WMS_SALES.DASHBOARD',

  LOGISTICS_SALES_LIST: 'MENU_WMS_LOGISTICS.SALES_ORDER',
  LOGISTICS_PURCHASE_LIST: 'MENU_WMS_LOGISTICS.PURCHASE_ORDER',
  LOGISTICS_SALES_SHIPMENT_LIST: 'MENU_WMS_LOGISTICS.SALES_SHIPMENT',
  LOGISTICS_PURCHASE_SHIPMENT_LIST: 'MENU_WMS_LOGISTICS.PURCHASE_SHIPMENT',
  LOGISTICS_DELIVERY_BILL_LIST: 'MENU_WMS_LOGISTICS.DELIVERY_BILL',
  LOGISTICS_DELIVERY_LIST: 'MENU_WMS_LOGISTICS.DELIVERY',
  LOGISTICS_DELIVERY_ROUTE_LIST: 'MENU_WMS_LOGISTICS.DELIVERY_ROUTE',
  LOGISTICS_VEHICLE_LIST: 'MENU_WMS_LOGISTICS.VEHICLE',
  LOGISTICS_SHIPPER_LIST: 'MENU_WMS_LOGISTICS.SHIPPER',
  LOGISTICS_DASHBOARD: 'MENU_WMS_LOGISTICS.DASHBOARD',

  FACILITY_LIST : 'MENU_WMS_LOGISTICS_ADMIN.FACILITY',
  PRODUCT_LIST: 'MENU_WMS_LOGISTICS_ADMIN.PRODUCT',
  INVENTORY_DETAIL_LIST: 'MENU_WMS_LOGISTICS_ADMIN.INVENTORY_DETAIL',
  LOGISTICS_ADMIN_DASHBOARD: 'MENU_WMS_LOGISTICS_ADMIN.DASHBOARD',
};
